import React from 'react';
import classnames from 'classnames';

import Icon from 'components/Misc/Icon';
import Show from 'components/Show';

const Avatar = ({ alt, src, online, small, className }) => {
	const imageClassName = classnames(
		'relative w-10 h-10',
		small && 'w-8 h-8',
		className
	);

	const placeholderClassName = classnames(
		'relative w-10 h-10 flex justify-center items-center bg-neutral-100 dark:bg-neutral-700 rounded-full select-none',
		small && 'w-8 h-8',
		className
	);

	const iconClassName = classnames(
		'text-neutral-400',
		!small && 'text-2xl',
		small && 'text-xl'
	);

	if (!src) {
		return (
			<div className={placeholderClassName}>
				<Icon
					icon="person"
					className={iconClassName}
				/>

				<Show if={online}>
					<span className="absolute top-0.5 left-0.5 flex h-2 w-2">
						<span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
						<span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
					</span>
				</Show>
			</div>
		);
	}

	return (
		<div className={imageClassName}>
			<img
				alt={alt}
				src={`${process.env.REACT_APP_CDN}/avatars/${src}`}
				className="object-cover w-full h-full rounded-full"
			/>

			<Show if={online}>
				<span className="absolute top-0.5 left-0.5 flex h-2 w-2">
					<span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
					<span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
				</span>
			</Show>
		</div>
	);
};

export default Avatar;